import {AssignmentType} from './assignement-type';
import {AbstractDecisionUpdaterService} from '../abstract-decision-updater.service';

export abstract class AbstractMarkUpdaterService extends AbstractDecisionUpdaterService<number> {
    protected constructor(private readonly assignment: AssignmentType) {
        super('assignments/' + assignment)
    }
}
